import React, { AnchorHTMLAttributes } from "react";

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    isRelative?: boolean;
}
/**
 * Remove all starting urls that contain themuse.com/
 * We include the trailing slash to exclude instances where the string
 * is url encoded such as within social media.
 */
export const convertUriToRelativeUrl = (url: string) => {
    let relativeUrl = url.split("themuse.com/").pop();
    if (!relativeUrl.startsWith("http") && !relativeUrl.startsWith("/")) {
        relativeUrl = `/${relativeUrl}`;
    }
    return relativeUrl;
};

/**
 * Creates an anchor <a> element.
 * * Ensures that all urls pointing to themuse are relative
 * * Ensures that relative urls begin with a slash, forcing them to the root.
 * * Adds noopener and noreferer to external links if they do not already have a rel.
 */
export const Link: React.FC<LinkProps> = ({
    children,
    href,
    rel,
    target,
    ...restProps
}) => {
    const url = convertUriToRelativeUrl(href);

    const targetProps = {
        target: target || url.startsWith("http") ? "_blank" : null,
        rel: rel || url.startsWith("http") ? "noopener noreferrer" : null
    };

    return (
        <a href={url} {...targetProps} {...restProps}>
            {children}
        </a>
    );
};
